var _mask, _g, _path, _path2, _path3, _path4, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithoutName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 24,
    viewBox: "0 0 120 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24.802V23.4024H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9337 11.0196L15.8101 16.3184L12.401 19.8441L8.99177 16.3184L7.68447 14.9664C9.17745 14.8733 10.5482 14.3133 11.6622 13.4253C11.8827 13.5032 12.1184 13.5476 12.3645 13.5476C13.5646 13.5476 14.5374 12.5414 14.5374 11.3004C14.5374 10.0592 13.5646 9.05317 12.3645 9.05317C11.1645 9.05317 10.1916 10.0592 10.1916 11.3004C10.1916 11.3343 10.1952 11.3674 10.1966 11.4009C9.3821 12.06 8.35728 12.4538 7.24304 12.4538C4.59261 12.4538 2.44406 10.2318 2.44406 7.49073C2.44406 4.7498 4.59261 2.52777 7.24304 2.52777C8.35728 2.52777 9.38197 2.92165 10.1965 3.58056C10.1952 3.61393 10.1916 3.64662 10.1916 3.68026C10.1916 4.92141 11.1645 5.92748 12.3645 5.92748C13.5646 5.92748 14.5374 4.92141 14.5374 3.68026C14.5374 3.66582 14.5357 3.65193 14.5355 3.63749C15.3608 2.94398 16.4126 2.52777 17.559 2.52777C20.2093 2.52777 22.3578 4.7498 22.3578 7.49073C22.3578 8.86127 21.8022 10.1215 20.9337 11.0196ZM17.559 -0.000183105C15.885 -0.000183105 14.3452 0.588726 13.1186 1.57478C12.8834 1.48462 12.6301 1.43287 12.3645 1.43287C12.1177 1.43287 11.8813 1.4774 11.6602 1.55599C10.4375 0.581099 8.90617 -0.000183105 7.24304 -0.000183105C3.24277 -0.000183105 0 3.35363 0 7.49057C0 9.56891 0.818727 11.4491 2.14038 12.8063L2.13999 12.8068L7.26358 18.1056L12.3851 23.4023L12.401 23.3859L12.4168 23.4023L17.5383 18.1056L22.662 12.8068C23.9727 11.4511 24.802 9.5591 24.802 7.49057C24.802 3.35363 21.5592 -0.000183105 17.559 -0.000183105Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7483 19.0103C35.4357 19.0103 32.2102 15.8428 32.2102 11.6898C32.2102 7.53686 35.4357 4.36926 39.7119 4.36926C42.6837 4.36926 45.1119 5.84746 46.5614 8.48703L43.9521 9.75415C43.0459 7.92394 41.5965 6.97364 39.7119 6.97364C37.1028 6.97364 35.1094 9.01506 35.1094 11.6898C35.1094 14.3646 37.1028 16.4059 39.7119 16.4059C41.7414 16.4059 43.2998 15.2797 44.1332 13.2383L46.8512 14.1182C45.6555 17.1802 42.9736 19.0103 39.7483 19.0103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5035 18.7231V17.2878C61.3336 18.4003 59.751 19.0103 57.962 19.0103C54.3839 19.0103 51.9756 16.2831 51.9756 12.1922V4.36926H54.6249V12.1922C54.6249 14.8477 55.8977 16.3548 58.1684 16.3548C60.7144 16.3548 62.5035 14.4888 62.5035 11.9051V4.36926H65.1525V18.7231H62.5035Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4664 8.99836C78.8978 7.63474 78.116 7.02471 76.9434 7.02471C75.0243 7.02471 73.7449 8.49601 73.7449 10.7925V19.0103H71.0088V4.65626H73.7449V5.51753C74.7046 4.72804 75.7351 4.36926 77.0143 4.36926C79.1821 4.36926 80.9233 5.51753 81.9895 7.63474L79.4664 8.99836Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6671 6.97351C91.1332 6.97351 89.1975 9.05 89.1975 11.7952C89.1975 14.3645 91.2036 16.4408 93.7025 16.4408C96.2364 16.4408 98.2074 14.3645 98.2074 11.6896C98.2074 9.0148 96.2364 6.97351 93.6671 6.97351ZM93.6319 19.0103C89.5143 19.0103 86.3818 15.8076 86.3818 11.5842C86.3818 7.57206 89.6199 4.36926 93.7025 4.36926C97.8553 4.36926 101.023 7.53686 101.023 11.6897C101.023 15.8428 97.8553 19.0103 93.6319 19.0103Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 4,
    width: 14,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.99 4.422H120V18.9658H106.99V4.422Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.395 18.5438V10.8085C117.395 8.135 116.138 6.63782 113.896 6.63782C111.416 6.63782 109.616 8.49154 109.616 11.0936V18.5438H107V4.28509H109.616V5.71096C110.804 4.60598 112.333 4 114.1 4C117.632 4 120.01 6.70913 120.01 10.8085V18.5438H117.395Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutName);
export default __webpack_public_path__ + "static/media/logo_without_name.68b7ff26afbb98c45a13dd3392fae01b.svg";
export { ForwardRef as ReactComponent };